// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2z5xJ","rightAdornment":"Header_rightAdornment__3VDuB"};